import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Stepper from '@material-ui/core/Stepper'
import { withRouter } from 'react-router'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Spinner from 'components/Spinner'
import ConfirmEmailStepComponent from './ConfirmEmailStepComponent'
import GeneralInformationsStepComponent from './GeneralInformations/GeneralInformationsStepComponent'
import HiboutikAccountCreationStepComponent from './HiboutikAccountCreation/HiboutikAccountCreationStepComponent'
import DashpoolConfigurationStepper from './DashpoolConfiguration/DashpoolConfigurationStepper'
import ButtonsStepperComponent from './ButtonsStepperComponent'
const styles = theme => ({
  root: {
    width: '100%'
  },
  stepperContent: {
    marginTop: theme.spacing.unit * 2,
    width: '100%'
  },
  backButton: {
    marginRight: theme.spacing.unit
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  }
})

class HorizontalLabelPositionBelowStepper extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    boarding: PropTypes.object.isRequired,
    updateBoarding: PropTypes.func.isRequired,
    updateConfig: PropTypes.func.isRequired,
    sendConfirmationEmail: PropTypes.func.isRequired,
    checkEmailVerification: PropTypes.func.isRequired,
    stepComplete: PropTypes.func.isRequired,
    checkAccountAvailability: PropTypes.func.isRequired,
    createHiboutikAccount: PropTypes.func.isRequired,
    updateTableTypeSettings: PropTypes.func.isRequired,
    updatePricing: PropTypes.func.isRequired,
    updateNavigationMenu: PropTypes.func.isRequired,
    updateSettingsStep: PropTypes.func.isRequired,
    checkAccountCreation: PropTypes.func.isRequired,
    boardingFinished: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
    classes: PropTypes.object
  }
  state = {
    isStepComplete: false,
    next: false,
    back: false
  }
  handleUpdate = (name, value) => {
    this.props.updateConfig(name, value)
  }
  getStepContent = stepIndex => {
    const {
      boarding,
      auth,
      checkAccountAvailability,
      createHiboutikAccount,
      updateTableTypeSettings,
      checkAccountCreation,
      updatePricing,
      updateNavigationMenu,
      updateSettingsStep
    } = this.props
    const { config, currentStepIndex, steps } = boarding
    const currentStep = steps[currentStepIndex]
    if (!this.props.boarding) return null
    switch (currentStepIndex) {
      case 0:
        return (
          <ConfirmEmailStepComponent
            checkEmailVerification={this.props.checkEmailVerification}
            sendEmail={this.props.sendConfirmationEmail}
            step={currentStep}
            auth={auth}
            goToNext={this.handleNext}
            completed={this.handleStepCompleted}
          />
        )
      case 1:
        return (
          <GeneralInformationsStepComponent
            step={currentStep}
            config={config}
            auth={auth}
            goToNext={this.handleNext}
            onChange={this.handleUpdate}
            completed={this.handleStepCompleted}
          />
        )
      case 2:
        return (
          <HiboutikAccountCreationStepComponent
            checkAccountAvailability={checkAccountAvailability}
            createHiboutikAccount={createHiboutikAccount}
            checkAccountCreation={checkAccountCreation}
            email={auth.email}
            config={config}
            goToNext={this.handleNext}
            onChange={this.handleUpdate}
            completed={this.handleStepCompleted}
            showModal={this.props.showModal}
          />
        )
      case 3:
        return (
          <DashpoolConfigurationStepper
            step={currentStep}
            settings={boarding.settings}
            goToNext={this.handleNext}
            completed={this.handleStepCompleted}
            updateTableTypeSettings={updateTableTypeSettings}
            updatePricing={updatePricing}
            updateNavigationMenu={updateNavigationMenu}
            updateSettingsStep={updateSettingsStep}
            onChange={this.handleUpdate}
          />
        )
      default:
        return null
    }
  }
  handleNext = (config = {}) => {
    const { boarding } = this.props
    const { steps } = boarding
    const currentStep = steps[boarding.currentStepIndex]
    if (boarding.finished) {
      this.props.boardingFinished()
      return
    }
    if (currentStep.isCompleted && !currentStep.hasErrors) {
      this.props.updateBoarding({
        ...boarding,
        config: {
          ...boarding.config,
          ...config
        },
        currentStepIndex: boarding.currentStepIndex + 1
      })
    }
  }

  handleBack = () => {
    const { boarding } = this.props
    const { steps } = boarding
    const currentStep = steps[boarding.currentStepIndex]
    if (currentStep.back) {
      this.props.updateBoarding({
        ...this.props.boarding,
        currentStepIndex: boarding.currentStepIndex - 1
      })
    }
  }
  handleStepCompleted = isStepCompleted => {
    const { boarding } = this.props
    this.props.stepComplete(boarding.currentStepIndex, isStepCompleted)
  }

  render() {
    const { classes, boarding } = this.props
    if (boarding.currentStepIndex === -1 || boarding.currentStepIndex > 3) {
      return <Spinner color="secondary" />
    }
    const { steps, currentStepIndex, finished } = boarding
    const currentStep = steps[currentStepIndex]
    let next = steps[currentStepIndex].isCompleted
    next = currentStepIndex === 0 ? false : next
    const back = currentStep.back
    const nextLabel = next ? void 0 : `Complétez l'étape`
    return (
      <div className={classes.root}>
        <Stepper activeStep={currentStepIndex} alternativeLabel>
          {steps.map(step => {
            return (
              <Step key={step.index}>
                <StepLabel>{step.name}</StepLabel>
              </Step>
            )
          })}
        </Stepper>
        <Grid
          alignItems="center"
          direction="row"
          justify="center"
          className={classes.stepperContent}
          container>
          <Grid item xs={10}>
            <Paper elevation={4}>{this.getStepContent(currentStep)}</Paper>
          </Grid>
          <Grid item xs={10}>
            <ButtonsStepperComponent
              steps={steps}
              isLastStep={finished || currentStepIndex - steps.length - 1 >= 0}
              activeStep={currentStepIndex}
              next={!next}
              nextLabel={nextLabel}
              back={!back}
              goBack={this.handleBack}
              goNext={this.handleNext}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

HorizontalLabelPositionBelowStepper.propTypes = {
  classes: PropTypes.object,
  auth: PropTypes.object.isRequired
}

export default withRouter(
  withStyles(styles)(HorizontalLabelPositionBelowStepper)
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/BoardingComponent.js